import React from 'react';
import styled from 'styled-components';

const MessageContainer = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  justify-content: center;
  margin: 16px;
  min-height: 23px;
  padding: 6px 20px;
  box-sizing: border-box;

  border-radius: 5px;
  border: solid 1px #f0f0f0;
  background-color: #ffffff;
  background-color: white;

  font-family: 'Montserrat', sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: #4a4a4a;
`;

const HandOverMessage = ({ activity }) => (
  <MessageContainer>{activity.operatorName} has taken over</MessageContainer>
);

export default HandOverMessage;



// WEBPACK FOOTER //
// ./src/components/MetaMessages/HandOverMessage.js